import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@root/manager-base/app-base/environment/paths/constants';
import { FileOcrDataInvoiceStatusDTO } from '@app/accounting/data/dto/file-ocr-data-invoice-status.dto';

const routeRoot = 'v1/ocr';
const baseRoute = `${BASE_PATH_API}/${routeRoot}`;

const actions = {
    filesToScan: {
        method: 'POST',
        url: `${baseRoute}/filesToScan`
    },
    getOCRStatus: {
        method: 'GET',
        url: `${baseRoute}/:fileId`
    }
};

export interface IOcrApi {
    filesToScan(params: { fileIds: number[], shouldReplaceExistingDraft: boolean }): Promise<unknown>;
    getOCRStatus(params: { fileId: number }): Promise<FileOcrDataInvoiceStatusDTO>;
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function OcrApi(): IOcrApi {
    return createActions(actions);
}
